export default __webpack_public_path__ + "static/media/fem_2.1e592388.png";